import React from "react";
import { Header, Comment, Label } from "semantic-ui-react";
import { SafeMoment } from "../../../../components/SafeMoment";
import ReactMarkdown from "react-markdown";

interface IPrintCommunication {
  comments: any;
}

export const PrintCommunication = ({ comments }: IPrintCommunication) => {
  return (
    <>
      <Header content='Communication' style={{ marginTop: 8, fontSize: 16 }} />
      <Comment.Group className={"comment-group"}>
        {comments.map(
          (
            {
              authorName,
              createdAt,
              body,
              commentAttachment,
            }: {
              authorName: string;
              createdAt: Date;
              body: string;
              commentAttachment: any;
            },
            index: number,
          ) => {
            return (
              <Comment key={index} style={{ display: "flex" }}>
                <Comment.Content></Comment.Content>

                <Comment.Content style={{ paddingLeft: "1rem", paddingTop: "0.25rem" }}>
                  <Comment.Author as='a'>{authorName}</Comment.Author>
                  <Comment.Metadata>
                    <div>
                      <SafeMoment format='MMMM D, LT'>{createdAt}</SafeMoment>
                    </div>
                  </Comment.Metadata>
                  <div className='comment-body'>
                    <ReactMarkdown>{body}</ReactMarkdown>
                  </div>
                  {
                    commentAttachment && commentAttachment.map((attachment: any) => {
                      const fileName = attachment.data.attributes.fileName
                      return (
                        <Label key={fileName} basic>{fileName}</Label>
                      )
                    })
                  }
                </Comment.Content>
              </Comment>
            );
          },
        )}
      </Comment.Group>
    </>
  );
};

export default PrintCommunication;
